import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Styled Components
const HeroSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 11rem;
  height: 70vh;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    height: auto;
    padding: 1rem 2rem;
  }
`;

const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-right: 2rem;

  @media (max-width: 768px) {
    margin-right: 0;
    align-items: center;
    text-align: center;
  }
`;

const HeroTitle = styled.h1`
  font-size: 58px;
  color: #000;
  font-weight: 800;
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 36px;
    max-width: 100%;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 22px;
  color: #555;
  margin: 20px 0;
  max-width: 600px;

  @media (max-width: 768px) {
    font-size: 18px;
    max-width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

const Button = styled.a`
  background-color:rgb(88, 199, 192);
  color: #fff;
  padding: 0.8rem 2rem;
  border-radius: 30px;
  text-decoration: none;
  margin-right: 15px;

  &:hover {
    background-color: #333;
  }

  @media (max-width: 768px) {
    margin: 10px 0;
    width: 80%;
    text-align: center;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
  transform: rotateY(15deg);
  perspective: 1000px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: rotateY(0deg) scale(1.05);
    box-shadow: 0 12px 30px rgb(88, 199, 192);
  }

  @media (max-width: 768px) {
    margin-top: 20px;
    width: 100%;
    transform: none;
  }
`;

const Image = styled.img`
  width: 100%;
  display: block;
  transform: translateZ(0);
`;

// Component
const Hero = () => (
  <HeroSection>
    <TextContainer>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        <HeroTitle>Hyperlocal Inventory Optimization Powered by AI</HeroTitle>
        <HeroSubtitle>
          Optimize not just <strong>what to keep, but where to keep</strong> in your micro-hubs for
          <strong> faster, hyperlocalized deliveries</strong> to your customers.
        </HeroSubtitle>
        <ButtonWrapper>
          <Button href="#Howitworks">Get Started</Button>
          <Button href="#Pricing">Schedule a Demo</Button>
        </ButtonWrapper>
      </motion.div>
    </TextContainer>

    <ImageContainer>
      <Image src="/assets/inven.png" alt="Showcase" />
    </ImageContainer>
  </HeroSection>
);

export default Hero;
